
import React from 'react';
import { _getLocalStorageKey } from '../../adapter/utils';
import {
    getGlobalStorage,
    setGlobalStorage,
} from '@platform/api';
import classnames from 'classnames';
import './index.less';

function useAutoMerge(Table) {
    return class MergeTable extends React.Component {

        render() {
            let { renderFlatButton } = this.props;
            return <>
                <div className="flat-button-area" >{renderFlatButton?.()}</div>
                <Table {...this.props} />
            </>;
        }
    };
}

useAutoMerge.displayName = 'useAutoMerge';
useAutoMerge.dependence = [];
useAutoMerge.propsGenerator = function (props) {
    let { rows, pkname, rowProps, store } = props;
    let { tableType } = store.getFlatInfo();
    if (tableType !== "flat") {
        return { ...props };
    }
    let lastPkValue = rows[0] && rows[0].values[pkname].value;
    let isDeep = false;
    // 主子拉平的斑马线
    rows.forEach(row => {
        if (row.values[pkname].value !== lastPkValue) {
            isDeep = !isDeep;
            lastPkValue = row.values[pkname].value;
            row.deep = isDeep;
        }
        row.deep = isDeep;
    });
    return {
        ...props,
        rowProps: (row, viewIndex) => {
            let rawRowProps = rowProps?.(row, viewIndex);
            return {
                ...rawRowProps,
                className: classnames(rawRowProps.className, {
                    'flat-row-deep': row.deep,
                    'flat-row-light': !row.deep,
                },
                ),
            };
        },
    };
};
useAutoMerge.hooks = function () {
    this.store.flatInfo = null;
    return {
        setFlatInfo: (info, { local = true, shouldUpdate = true } = {}) => {
            this.store.flatInfo = info;
            this.setMainId(info.tableId, { shouldUpdate });
            local && setLocalFlatInfo(this.store.meta, this.getConfig()?.id, info);
        },
        getFlatInfo: (meta, moduleId) => {
            meta = meta ?? this.store.meta;
            moduleId = moduleId ?? this.getConfig()?.id;

            // store优先local
            let flatInfo = this.store.flatInfo ?? getLocalFlatInfo(meta, moduleId) ?? {},
                childTableCode = meta?.[moduleId]?._layoutData?.childTableCode;

            // 这个区域没有子表，或者meta里没有子表这个区域
            if (!childTableCode || (meta && !meta[flatInfo.tableId])) {
                flatInfo = {
                    tableId: moduleId,
                    tableType: 'parent',
                };
            }

            return flatInfo;
        },
        /**
         * 获取拉平表主子关联关系
         * @function
         * @private
         * @returns {}
        */
        getFlatRelation: () => {
            return {
                pkToRowId: this.store.pkToRowIdRelation ?? {}, //setAllRowsInfo加入     主表pk=>关联rowKey
                rowIdRelationMap: this.store.rowIdRelation ?? {}, //setAllRowsInfo加入    rowKey=>关联rowKey
                pkRelationMap: this.store.pkRelationMap ?? {}, // pk关联关系 {parentToChildren, childToParent, childToChildren}
            };
        },
        isFlatStatus: () => {
            return this.getFlatInfo().tableType === 'flat';
        },
    };
};

// 将当前表格类型(主表/拉平表)存储至本地
export function setLocalFlatInfo(meta, id, info) {
    let savedKey = _getLocalStorageKey(meta, id, 'flat'),
        savedValue = getGlobalStorage('localStorage', 'flat_table');

    if (savedValue) {
        savedValue = JSON.parse(savedValue);
    } else {
        savedValue = {};
    }

    savedValue = {
        ...savedValue,
        [savedKey]: info,
    };

    setGlobalStorage('localStorage', 'flat_table', JSON.stringify(savedValue));
}

//获取表格类型
export function getLocalFlatInfo(meta, id) {
    let savedKey = _getLocalStorageKey(meta, id, 'flat'),
        savedValue = getGlobalStorage('localStorage', 'flat_table') || {};

    if (typeof savedValue === 'string') {
        savedValue = JSON.parse(savedValue);
    } else {
        savedValue = {};
    }

    return savedValue?.[savedKey] || {};
}

// 通过子表的rowKey，找到所有子表行同属某一个主表行的rowKey
export function getRowKeysByChildRowKey(childRowKey, store) {
    let { rowDataMap, rowKeys, meta } = normalize(store);
    let pkName = meta.metaJson?.head?.pk,
        currentPkValue = rowDataMap[childRowKey].values[pkName].value;

    let relationRowKeys = rowKeys.filter(rowKey => {
        if (rowDataMap[rowKey].values[pkName].value === currentPkValue) {
            return true;
        } else {
            return false;
        }
    });
    return relationRowKeys;
}
// store可能是方法也可能是store实例
function normalize(store) {
    let { rowKeys, rowDataMap, meta } = store || {};
    if (rowKeys && rowDataMap && meta) {
        return { rowKeys, rowDataMap, meta };
    }
}

export default useAutoMerge;